<div class="container" [style.backgroundColor]="bgColor" [style.color]="textColor">
  {{ text }}
</div>
